import { lazy } from "react";

export const GetStartedAnimation = lazy(() => import("./get-started-animation.svg?react"));
